/** tableau de couple [nature juridique/categorie] */
const naturesJuridiquesCategoriesPes = [
	{
		key: '01/01',
		value: '01 Particuliers/01 Personnes Physiques',
	},
	{
		key: '02/01',
		value: '02 Artisan, Commerçant ou Agriculteur/01 Personnes Physiques',
	},
	{
		key: '03/50',
		value:
			"03 Société/50 Personnes morales de droits PRIVÉ autres qu'organismes sociaux",
	},
	{
		key: '04/60',
		value:
			'04 CAM ou caisse appliquant les mêmes règles/60 Caisses de sécurité sociale régime général',
	},
	{
		key: '04/61',
		value:
			'04 CAM ou caisse appliquant les mêmes règles/61 Caisses de sécurité sociale régime agricole',
	},
	{
		key: '04/62',
		value:
			'04 CAM ou caisse appliquant les mêmes règles/62 Sécurité sociale des travailleurs Non salariés et professions Non agricoles',
	},
	{
		key: '04/63',
		value:
			'04 CAM ou caisse appliquant les mêmes règles/63 Autres régimes obligatoires de sécurité sociale',
	},
	{
		key: '04/64',
		value:
			"04 CAM ou caisse appliquant les mêmes règles/64 Mutuelles et organismes d'assurance",
	},
	{
		key: '04/65',
		value:
			'04 CAM ou caisse appliquant les mêmes règles/65 Divers autres tiers payants',
	},
	{
		key: '04/72',
		value: '04 CAM ou caisse appliquant les mêmes règles/72 ASSEDIC',
	},
	{
		key: '05/65',
		value: '05 Caisse complémentaire/65 Divers autres tiers payants',
	},
	{
		key: '05/70',
		value: '05 Caisse complémentaire/70 CNRACL',
	},
	{
		key: '05/71',
		value: '05 Caisse complémentaire/71 IRCANTE',
	},
	{
		key: '05/73',
		value:
			'05 Caisse complémentaire/73 Caisses mutualistes de retaites complémentaires',
	},
	{
		key: '06/50',
		value:
			"06 Association/50 Personnes morales de droits PRIVÉ autres qu'organismes sociaux",
	},
	{
		key: '07/20',
		value:
			"07 Etat ou organisme d'Etat/20 État et établissement publics nationaux",
	},
	{
		key: '08/20',
		value:
			'08 Etablissement PUBLIC national/20 État et établissement publics nationaux',
	},
	{
		key: '08/28',
		value:
			'08 Etablissement PUBLIC national/28 École nationale de la santé PUBLIQUE',
	},
	{
		key: '09/21',
		value: '09 Collectivité territoriale, EPL ou EPS/21 Régions',
	},
	{
		key: '09/22',
		value: '09 Collectivité territoriale, EPL ou EPS/22 départements',
	},
	{
		key: '09/23',
		value: '09 Collectivité territoriale, EPL ou EPS/23 Communes',
	},
	{
		key: '09/24',
		value:
			'09 Collectivité territoriale, EPL ou EPS/24 Groupements de collectivités',
	},
	{
		key: '09/25',
		value: '09 Collectivité territoriale, EPL ou EPS/25 Caisses des écoles',
	},
	{
		key: '09/26',
		value: '09 Collectivité territoriale, EPL ou EPS/26 CCAS',
	},
	{
		key: '09/27',
		value:
			'09 Collectivité territoriale, EPL ou EPS/27 Établissements publics de santé',
	},
	{
		key: '10/29',
		value:
			'10 Etat étranger ou ambassade/29 Autres établissements publics et organismes internationaux',
	},
	{
		key: '11/63',
		value: '11 CAF/63 Autres régimes obligatoires de sécurité sociale',
	},
];

export default naturesJuridiquesCategoriesPes;
